import axios from 'axios'
import HeaderBlock from '@/partials/Header/Header.vue'
import Intro from './Intro/Intro.vue'
// import Timer from './Timer/Timer.vue'
import Benefits from './Benefits/Benefits.vue'
import CguToken from './CguToken/CguToken.vue'
import Projects from './Projects/Projects.vue'
import StackingResults from './StackingResults/StackingResults.vue'
import Subscribe from './Subscribe/Subscribe.vue'
import Faq from './FAQ/FAQ.vue'
// import Partners from './Partners/Partners.vue'
import FooterBlock from '@/partials/Footer/Footer.vue'
import WeeklyRewards from '@/pages/Home/WeeklyRewards/WeeklyRewards.vue'
import { mapGetters, mapState } from 'vuex'
import BigNumber from 'bignumber.js'
import { format } from '@/utils/moneyFormat'
import { getRewardInfo } from '@/api/crm'

export default {
  name: 'Home',
  components: {
    HeaderBlock,
    Intro,
    // Timer,
    Benefits,
    CguToken,
    Projects,
    StackingResults,
    WeeklyRewards,
    Subscribe,
    Faq,
    // Partners,
    FooterBlock,
  },
  data () {
    return {
      stakers: null,
      rewards: null,
      totalRewardsInCgu: null,
      totalRewardsInUsd: null
    }
  },
  beforeCreate () {
    document.title = 'CGU Staking'
  },
  computed: {
    ...mapState({
      usdtPrice: state => state.usdtPrice,
      cguPrice: state => state.cguPrice,
    }),
    ...mapGetters({
      totalApy: 'totalApy',
      totalStakedInUsdt: 'network/totalStakedInUsdt',
      totalStakedInCgu: 'network/totalStakedInCgu',
      rewardApy: 'rewardApy',
    }),
    poolRewardApy () {
      return new BigNumber(this.rewardApy).toFixed(2)
    },
    totalStakedInUsdtFormatted () {
      if (this.totalStakedInUsdt === null) {
        return 0
      }
      return format(this.totalStakedInUsdt, {
        toFixedNumber: 0,
      })
    },
    totalStakedInCguFormatted () {
      if (this.totalStakedInCgu === null) {
        return 0
      }
      return format(this.totalStakedInCgu, {
        toFixedNumber: 0,
      })
    },
    stakedUsd () {
      if (+this.totalStakedInCgu === 0 || this.cguPrice === null) {
        return 0
      }
      const usdtUsd = new BigNumber(this.totalStakedInUsdt).multipliedBy(this.usdtPrice)
      const cguUsd = new BigNumber(this.totalStakedInCgu).multipliedBy(this.cguPrice)
      return format(usdtUsd.plus(cguUsd), {
        toFixedNumber: 0,
      })
    },
  },
  async created () {
    try {
      const { data } = await axios.get('https://axie-mon-api.chronobank.io/api/v1/common/cgu-stackers-count')
      this.stakers = data?.result || 51

      const rewardsInfo = await getRewardInfo()
      this.rewards = rewardsInfo?.listWeeklyRewards
      this.totalRewardsInCgu = format(rewardsInfo?.tokensCguDistributed, {
        toFixedNumber: 0,
      })
      this.totalRewardsInUsd = format(rewardsInfo?.tokensCguDistributedInUsd, {
        toFixedNumber: 0,
      })
    } catch (err) {
      console.error('error count stackers', err)
    }
  },
  methods: {
    rewardFormatted (value) {
      return format(value, {
        toFixedNumber: 2,
      })
    },
  },
}
